module.exports = __webpack_public_path__ + "media/images/information/maintenance-62a52c275c16fb23beefacc2b209ef75.svg";